import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/app/store/store';

export type AbTestingState = {
  abUid: string | null;
};

const initialState: AbTestingState = {
  abUid: null,
};

const abTestingSlice = createSlice({
  name: 'abTesting',
  initialState,
  reducers: {
    setAbUid(state, action: PayloadAction<string | null>) {
      state.abUid = action.payload;
    },
  },
});

export const { setAbUid } = abTestingSlice.actions;
export const abTestingReducer = abTestingSlice.reducer;

export const selectAbUid = (state: RootState) => state.abTesting.abUid;

